module.exports = __webpack_public_path__ + "img/tc-9.9ebf8f9c.png";